// // npm i intersection-observer if there are no browser support for it
// import 'intersection-observer';

// lazy loading (https://github.com/verlok/lazyload)
export const initLazyLoading = () => {
    if (document.querySelector('.lazy') !== null) {
        const b = document.body;
        const s = document.createElement('script');

        s.async = true;
        s.src = 'https://cdnjs.cloudflare.com/ajax/libs/vanilla-lazyload/10.15.0/lazyload.min.js';
        window.lazyLoadOptions = {
            elements_selector: '.lazy',
            to_webp: true
        };
        b.appendChild(s);
    }
};
